import { CaseStage } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseStageMessages = defineMessages({
  complete: {
    defaultMessage: 'Complete',
    description: 'case stage name',
  },
  onboarding: {
    defaultMessage: 'Onboarding',
    description: 'case stage name',
  },
  servicing: {
    defaultMessage: 'Servicing',
    description: 'case stage name',
  },
  uncontacted: {
    defaultMessage: 'Uncontacted',
    description: 'case stage name',
  },
})

export function translateCaseStage(intl: IntlShape, stage: CaseStage): string {
  switch (stage) {
    case CaseStage.UNCONTACTED:
      return intl.formatMessage(caseStageMessages.uncontacted)
    case CaseStage.ONBOARDING:
      return intl.formatMessage(caseStageMessages.onboarding)
    case CaseStage.SERVICING:
      return intl.formatMessage(caseStageMessages.servicing)
    case CaseStage.COMPLETE:
      return intl.formatMessage(caseStageMessages.complete)
  }
}
